import { Form, Input, Row, Select } from "antd";
import { useCallback } from "react";
import { toast } from "react-toastify";

import { CepService } from "../../../../services/cep.service";
import { listCidades } from "../../../../utils/getCidades";
import { InputCep } from "../InputCep";

const { Option } = Select;

export function Endereco({ form, setLoading }) {
  const getAddress = useCallback(
    async (cep) => {
      setLoading(true);

      try {
        const { data } = await CepService.get({ cep });
        const { bairro, id, municipio, rua, tipo, uf } = data;

        const findCidade = listCidades.find(
          (v) => v.nome.toLocaleLowerCase() === municipio.toLocaleLowerCase()
        );
        form.setFieldsValue({
          bairro,
          cep,
          id,
          cidade: findCidade ? findCidade.nome : null,
          endereco: rua,
          tipo,
          uf,
        });
      } catch (err) {
        toast.error("Falha na busca do CEP");
      } finally {
        setLoading(false);
      }
    },
    [form, setLoading]
  );

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Endereço</div>
      </Row>
      <br />

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          label="CEP"
          name="cep"
          rules={[{ required: true, message: "Por favor informe seu CEP!" }]}
        >
          <InputCep
            onBlur={(e) => {
              const cep = e.target.value;
              if (cep) {
                getAddress(cep);
              }
            }}
          />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="Endereço"
          name="endereco"
          rules={[{ required: true, message: "Por favor informe o endereço!" }]}
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyleNumero"
          label="Número"
          name="numero"
          rules={[{ required: true, message: "Por favor informe o Número!" }]}
        >
          <Input />
        </Form.Item>
      </div>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyleNumero"
          label="Complemento"
          name="complemento"
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="Bairro"
          name="bairro"
          rules={[{ required: true, message: "Por favor informe o bairro!" }]}
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        {/* <Form.Item
          label="UF"
          name="estado"
          rules={[{ required: true, message: "Por favor informe seu RG!" }]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {listUF.map((lista) => {
              return (
                <Option key={lista.id} value={lista.sigla}>
                  {lista.sigla}
                </Option>
              );
            })}
          </Select>
        </Form.Item> */}

        <Form.Item
          className="inputStyle"
          label="Cidade"
          name="cidade"
          rules={[{ required: true, message: "Por favor informe a cidade!" }]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {listCidades.map((lista) => {
              return (
                <Option key={lista.id} value={lista.nome}>
                  {lista.nome}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </div>
    </>
  );
}
